import gql from 'graphql-tag';

const FETCH_SMS_PROFILE = gql`
  query FetchSmsProfile {
    getSmsProfile {
      phone
      consentTypes {
        marketing
      }
    }
  }
`;

export default FETCH_SMS_PROFILE;
